import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { s as slotFilled } from './index3.js';
import { d as defineCustomElement$8 } from './badge.js';
import { d as defineCustomElement$7 } from './close-button.js';
import { d as defineCustomElement$6 } from './icon.js';
import { d as defineCustomElement$5 } from './input-button.js';
import { d as defineCustomElement$4 } from './loader.js';
import { d as defineCustomElement$3 } from './menu-pane.js';
import { d as defineCustomElement$2 } from './tooltip.js';
import { d as defineCustomElement$1 } from './tooltip-label.js';

const inputMenuCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex:1;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}wui-input-button [slot=prefix-icon]{display:inline-flex}";
const WuiInputMenuStyle0 = inputMenuCss;

const WuiInputMenu = /*@__PURE__*/ proxyCustomElement(class WuiInputMenu extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.clear = createEvent(this, "clear", 3);
        this.openChanged = createEvent(this, "openChanged", 3);
        this.disabled = false;
        this.loading = false;
        this.inputButton = undefined;
        this.menuPane = undefined;
        this.open = false;
        this.alignment = 'start';
    }
    async _handleKeyDown(e) {
        const wuiMenuPaneElement = this.el.shadowRoot?.querySelector('wui-menu-pane');
        if (wuiMenuPaneElement && (await wuiMenuPaneElement.handleKeyDown(e))) {
            // Event was handled by menu pane
            this.toggleOpen(!!wuiMenuPaneElement.open);
            return;
        }
        const wuiListElement = this.el.shadowRoot?.querySelector('wui-list');
        if (wuiListElement && (await wuiListElement.handleKeyDown(e))) {
            return;
        }
    }
    toggleOpen(open = !this.open) {
        if (open === this.open) {
            return;
        }
        this.open = open;
        this.openChanged.emit(this.open);
    }
    render() {
        return (h(Host, { key: '4337a3c4990eed1275a2e093dc78cf0f7e8b5abc' }, h("wui-input-button", { key: 'a367166784c4392437a6d86560e185d4f36c8531', loading: this.loading, disabled: this.disabled || this.loading, open: this.open, onClear: (e) => {
                // We're going to emit the event again in this component, so stop the inner event
                // from bubbling upwards
                e.preventDefault();
                e.stopPropagation();
                // Emit the event again
                this.clear.emit();
            }, onClick: () => {
                this.open = !this.open;
            }, onBlur: (e) => {
                if (e.relatedTarget && e.relatedTarget instanceof HTMLElement && this.el.contains(e.relatedTarget)) {
                    // Don't fire blur event when focus is still inside of this component
                    e.stopPropagation();
                }
            }, ...this.inputButton }, slotFilled(this.el, 'prefix-icon') && h("slot", { key: 'a773a06709ffdb62cb0ff65667c4ab5aa49f3d3b', name: "prefix-icon", slot: "prefix-icon" })), h("wui-menu-pane", { key: '1ee9b16ca543064dd1489cdc4c0d599e8d9d9bec', open: this.open, onClickOutside: () => {
                this.toggleOpen(false);
            }, onOpenChanged: (e) => {
                this.toggleOpen(e.detail);
            }, placement: `bottom-${this.alignment ?? 'start'}`, stretch: "min", ...this.menuPane }, h("slot", { key: 'e9010276802442841d759104a5978395c07ab9ec' }))));
    }
    get el() { return this; }
    static get style() { return WuiInputMenuStyle0; }
}, [1, "wui-input-menu", {
        "disabled": [516],
        "loading": [516],
        "inputButton": [16],
        "menuPane": [16],
        "open": [1540],
        "alignment": [1]
    }, [[0, "keydown", "_handleKeyDown"]]]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-input-menu", "wui-badge", "wui-close-button", "wui-icon", "wui-input-button", "wui-loader", "wui-menu-pane", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-input-menu":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiInputMenu);
            }
            break;
        case "wui-badge":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-input-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiInputMenu as W, defineCustomElement as d };

//# sourceMappingURL=input-menu.js.map